import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { selector } from "../../../../api";
import { invoiceCRUD } from "../../../../actions/invoice";
import { TableShared } from "../../../../shared";
import { char } from "../../../../utils";
import { Badge, Button, Dropdown, Space, notification } from "antd";
import { SyncOutlined, MoreOutlined } from "@ant-design/icons";
import { AccountTransaction } from "../../../invoice/transaction/content";

const items = [
  {
    label: "Transaction",
    key: "transaction",
    icon: <SyncOutlined />,
  },
];

export const InstitutionAccount = () => {
  let location = useLocation();

  const centerId = location.state && location.state.center;

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataId, setDataId] = useState(null);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [index, setIndex] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortType, setSortType] = useState("");

  const [api, contextHolder] = notification.useNotification();

  const user = selector.User();

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      invoiceCRUD
        .loadInstitutionAccount(
          postsPerPage,
          nextPage,
          centerId,
          "",
          value,
          sortType === "desc" ? "-" + sortColumn : sortColumn
        )
        .then((resp) => {
          setData(resp.data.results);
          setCount(resp.data.count);
        })
        .catch((error) => {
          api.error({
            message: error.message,
            description:
              "Oops! It looks like you're not connected to the network. Please check your network connectivity and try again",
            placement: "topRight",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }, 500);
  }, [page, postsPerPage, value, index, nextPage, sortColumn, sortType]);

  const defaultColumns = [
    {
      key: "sn",
      title: "#",
      dataIndex: "sn",
      fixed: true,
      width: 150,
    },
    {
      key: "account_code",
      title: "Account Code",
      dataIndex: "account_code",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "name",
      title: "Full Name",
      dataIndex: "name",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "gfs_code",
      title: "GFS Code",
      dataIndex: "gfs_code",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      sortable: true,
      width: 150,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (record) => (
        <Dropdown
          menu={{
            items,
            onClick: (event) => {
              switch (event.key) {
                case "transaction":
                  setOpen(true);
                  setDataId(record.id);
                  break;
                default:
              }
            },
          }}
          placement="bottomRight"
          arrow={{ pointAtCenter: true }}
          trigger={["click"]}
        >
          <Space>
            <Button type="dashed" icon={<MoreOutlined />} size={"middle"} />
          </Space>
        </Dropdown>
      ),
    },
  ];

  const dataItem = data?.map((dt, i) => ({
    id: dt.id,
    sn: i + 1,
    account_code: dt.account_code ? char.toUpperCase(dt.account_code) : "N/A",
    name: dt.name ? char.toTitleCase(dt.name) : "N/A",
    gfs_code: dt.gfs_code ? dt.gfs_code : "N/A",
    status: dt.is_active ? (
      <span class="badge badge-soft-success badge-border">
        {char.toTitleCase("active")}
      </span>
    ) : (
      <span class="badge badge-soft-danger badge-border">
        {char.toTitleCase("inactive")}
      </span>
    ),
  }));

  return (
    <>
      {contextHolder}
      <AccountTransaction
        open={open}
        setOpen={setOpen}
        dataId={dataId}
        account={"institution"}
      />
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-12">
            <p className="h6 fs-18 fw-bold text-dark">Institution Account</p>
          </div>
          <hr className="mt-3" />
        </div>
        <TableShared
          setOpen={setOpen}
          loading={loading}
          data={dataItem}
          setData={setData}
          page={page}
          setPage={setPage}
          count={count}
          postsPerPage={postsPerPage}
          setePostPerPage={setePostPerPage}
          setNextPage={setNextPage}
          value={value}
          setValue={setValue}
          defaultColumns={defaultColumns}
          button={null}
          link={"#"}
          showButton={true}
          sortColumn={sortColumn}
          setSortColumn={setSortColumn}
          sortType={sortType}
          setSortType={setSortType}
          setLoading={setLoading}
        />
      </div>
    </>
  );
};
